<div [class]="containerClasses">
  <div #toolbarContainer *ngIf="shouldShowToolbar">
    <div [class]="toolbarClasses">

    <!-- Signer Management Section -->
    <div class="toolbar-section signer-section">
      <h3>{{ translations?.signers?.title || 'Signers' }}</h3>
      <div class="signer-list" *ngIf="signers.length > 0; else noSignersTemplate">
        <div
          *ngFor="let signer of signers"
          class="signer-item"
          [class.active]="signer.id === activeSignerId"
          (click)="activateSigner(signer.id)"
          [title]="(translations?.signers?.clickToActivate || 'Click to activate') + ' ' + signer.name">
          <div class="signer-color" [style.backgroundColor]="signer.color"></div>
          <div class="signer-info">
            <div class="signer-name">{{signer.name}}</div>
            <div class="signer-email">{{signer.email}}</div>
            <span
              *ngIf="signer.signMethodLabel"
              class="signer-method-badge"
              [style.color]="signer.signMethodColor"
              [style.backgroundColor]="signer.signMethodBgColor">
              {{signer.signMethodLabel}}
            </span>
          </div>
          <div class="signer-status" *ngIf="signer.id === activeSignerId">
            <span class="active-indicator">●</span>
          </div>
        </div>
      </div>
      <ng-template #noSignersTemplate>
        <div class="no-signers-message">
          <p>{{ translations?.signers?.noSigners || 'No signers added yet.' }}</p>
          <p>{{ translations?.signers?.addSignersMessage || 'Add signers externally to enable form elements.' }}</p>
        </div>
      </ng-template>
    </div>

    <div class="toolbar-section">
      <h3>{{ translations?.modal?.properties || 'Form Elements' }}</h3>
      <div class="element-buttons">
        <button
          *ngFor="let element of filteredAvailableElements"
          (click)="selectElementType(element.type)"
          class="element-button"
          [class.active]="activeElementType === element.type"
          [class.disabled]="isElementDisabled(element.type)"
          [disabled]="isElementDisabled(element.type)"
          [title]="isElementDisabled(element.type) ? element.label + ' ' + (translations?.tooltips?.disabled || '(Disabled)') : element.label">
          <i [class]="element.icon" *ngIf="toolbarOptions.showIcons"></i>
          <span class="label" *ngIf="toolbarOptions.showLabels">{{element.label}}</span>
        </button>
      </div>
    </div>

    </div>
  </div>

  <!-- PDF Viewer with ng2-pdf-viewer -->
  <div class="pdf-container" #pdfContainer>
    <pdf-viewer
      #pdfViewer
      [src]="pdfSrc"
      [(page)]="page"
      [rotation]="rotation"
      [show-all]="true"
      [zoom]="zoom"
      [render-text]="false"
      [external-link-target]="'blank'"
      (error)="onError($event)"
      (change)="onPDFChange($event)"
      (pages-initialized)="onPagesInitialized($event)"
      (after-load-complete)="onPdfLoad($event)"
      (page-rendered)="onPageRendered($event)"
      style="display: block; width: 100%; height: 100%; position: absolute;">
    </pdf-viewer>
  </div>


  <!-- Integrated Edit Modal -->
  <div class="modal-overlay" *ngIf="isEditModalVisible" (click)="closeEditModal()">
    <div class="modal-dialog" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h3>{{ translations?.modal?.editElement ? t('modal.editElement', {type: getElementTypeLabel(editingElement?.type || '')}) : ('Edit ' + (editingElement?.type | titlecase) + ' Element') }}</h3>
        <button class="modal-close" (click)="closeEditModal()">×</button>
      </div>

      <div class="modal-body" *ngIf="editingElement">
        <!-- Common Name Field for all elements -->
        <div class="form-group">
          <label for="elementName">{{ editingElement.type === 'radio-button' ? t('fields.groupName') : t('fields.name') }}:</label>
          <input id="elementName" type="text" [(ngModel)]="editForm.name" class="form-input"
                 [disabled]="editingElement.type === 'signature' || editingElement.type === 'biometric-signature' || editingElement.type === 'digital-signature' || editingElement.type === 'initials'">
        </div>

        <!-- Read Only checkbox for non-signature elements -->
        <div class="form-group" *ngIf="editingElement.type !== 'signature' && editingElement.type !== 'biometric-signature' && editingElement.type !== 'digital-signature' && editingElement.type !== 'initials'">
          <label>
            <input type="checkbox" [(ngModel)]="editForm.isReadOnly" class="form-checkbox">
            {{ t('fields.readOnly') }}
          </label>
        </div>

        <!-- Text Input Properties -->
        <div *ngIf="editingElement.type === 'text-input'">
          <div class="form-group">
            <label for="placeholder">{{ t('fields.placeholder') }}:</label>
            <input id="placeholder" type="text" [(ngModel)]="editForm.properties.placeholder" class="form-input">
          </div>
          <div class="form-group">
            <label for="defaultValue">{{ t('fields.defaultValue') }}:</label>
            <input id="defaultValue" type="text" [(ngModel)]="editForm.properties.defaultValue" class="form-input">
          </div>
          <div class="form-group">
            <label for="fontSize">{{ t('fields.fontSize') }}:</label>
            <input id="fontSize" type="number" [(ngModel)]="editForm.properties.fontSize" min="8" max="72" class="form-input">
          </div>
          <div class="form-group">
            <label for="textColor">{{ t('fields.textColor') }}:</label>
            <input id="textColor" type="color" [(ngModel)]="editForm.properties.textColor" class="form-input">
          </div>
          <div class="form-group" style="display: none;">
            <label for="backgroundColor">{{ t('fields.backgroundColor') }}:</label>
            <input id="backgroundColor" type="color" [(ngModel)]="editForm.properties.backgroundColor" class="form-input">
          </div>
          <div class="form-group" style="display: none;">
            <label for="borderColor">{{ t('fields.borderColor') }}:</label>
            <input id="borderColor" type="color" [(ngModel)]="editForm.properties.borderColor" class="form-input">
          </div>
          <div class="form-group">
            <label>
              <input type="checkbox" [(ngModel)]="editForm.properties.required" class="form-checkbox">
              {{ t('fields.required') }}
            </label>
          </div>
        </div>

        <!-- Radio Button Properties -->
        <div *ngIf="editingElement.type === 'radio-button'">
          <div class="form-group">
            <label for="selectedValue">{{ t('fields.selectedValue') }}:</label>
            <input id="selectedValue" type="text" [(ngModel)]="editForm.properties.selectedValue" class="form-input">
          </div>
          <div class="form-group" style="display: none;">
            <label for="label">{{ t('fields.label') }}:</label>
            <input id="label" type="text" [(ngModel)]="editForm.properties.label" class="form-input">
          </div>
          <div class="form-group" style="display: none;">
            <label for="radioFontSize">{{ t('fields.fontSize') }}:</label>
            <input id="radioFontSize" type="number" [(ngModel)]="editForm.properties.fontSize" min="8" max="72" class="form-input">
          </div>
          <div class="form-group" style="display: none;">
            <label for="radioTextColor">{{ t('fields.textColor') }}:</label>
            <input id="radioTextColor" type="color" [(ngModel)]="editForm.properties.textColor" class="form-input">
          </div>
          <div class="form-group" style="display: none;">
            <label for="buttonColor">{{ t('fields.buttonColor') }}:</label>
            <input id="buttonColor" type="color" [(ngModel)]="editForm.properties.buttonColor" class="form-input">
          </div>
          <div class="form-group">
            <label>
              <input type="checkbox" [(ngModel)]="editForm.properties.checked" class="form-checkbox">
              {{ t('fields.checked') }}
            </label>
          </div>
          <div class="form-group">
            <label>
              <input type="checkbox" [(ngModel)]="editForm.properties.required" class="form-checkbox">
              {{ t('fields.required') }}
            </label>
          </div>
        </div>

        <!-- Checkbox Properties -->
        <div *ngIf="editingElement.type === 'checkbox'">
          <div class="form-group" style="display: none;">
            <label for="checkboxLabel">{{ t('fields.label') }}:</label>
            <input id="checkboxLabel" type="text" [(ngModel)]="editForm.properties.label" class="form-input">
          </div>
          <div class="form-group" style="display: none;">
            <label for="checkboxFontSize">{{ t('fields.fontSize') }}:</label>
            <input id="checkboxFontSize" type="number" [(ngModel)]="editForm.properties.fontSize" min="8" max="72" class="form-input">
          </div>
          <div class="form-group" style="display: none;">
            <label for="checkboxTextColor">{{ t('fields.textColor') }}:</label>
            <input id="checkboxTextColor" type="color" [(ngModel)]="editForm.properties.textColor" class="form-input">
          </div>
          <div class="form-group" style="display: none;">
            <label for="checkColor">{{ t('fields.checkColor') }}:</label>
            <input id="checkColor" type="color" [(ngModel)]="editForm.properties.checkColor" class="form-input">
          </div>
          <div class="form-group">
            <label>
              <input type="checkbox" [(ngModel)]="editForm.properties.checked" class="form-checkbox">
              {{ t('fields.checked') }}
            </label>
          </div>
          <div class="form-group">
            <label>
              <input type="checkbox" [(ngModel)]="editForm.properties.required" class="form-checkbox">
              {{ t('fields.required') }}
            </label>
          </div>
        </div>

        <!-- Text Element Properties -->
        <div *ngIf="editingElement.type === 'text'">
          <div class="form-group">
            <label for="textContent">{{ t('fields.text') }}:</label>
            <textarea id="textContent" [(ngModel)]="editForm.properties.text" class="form-input" rows="3" [placeholder]="t('placeholders.enterText')"></textarea>
          </div>

          <!-- Rich Editor Toolbar Row -->
          <div class="text-toolbar-row">
            <!-- Font Size -->
            <select [(ngModel)]="editForm.properties.fontSize" class="toolbar-select-small" [title]="t('tooltips.fontSize')">
              <option [value]="8">8</option>
              <option [value]="9">9</option>
              <option [value]="10">10</option>
              <option [value]="11">11</option>
              <option [value]="12">12</option>
              <option [value]="14">14</option>
              <option [value]="16">16</option>
              <option [value]="18">18</option>
              <option [value]="20">20</option>
              <option [value]="24">24</option>
              <option [value]="28">28</option>
              <option [value]="32">32</option>
              <option [value]="36">36</option>
              <option [value]="48">48</option>
              <option [value]="72">72</option>
            </select>

            <!-- Font Family -->
            <select [(ngModel)]="editForm.properties.fontFamily" class="toolbar-select-small" [title]="t('tooltips.fontFamily')">
              <option value="Arial">Arial</option>
              <option value="Times New Roman">Times</option>
              <option value="Courier New">Courier</option>
              <option value="Georgia">Georgia</option>
              <option value="Verdana">Verdana</option>
            </select>

            <!-- Text Color with Palette -->
            <div class="color-picker-wrapper">
              <button type="button" class="color-picker-button" (click)="toggleColorPalette()" [title]="t('tooltips.textColor')">
                <span class="color-indicator" [style.backgroundColor]="editForm.properties.textColor || '#000000'"></span>
              </button>
              <div class="color-palette-popup" *ngIf="showColorPalette">
                <div class="color-palette-grid">
                  <button *ngFor="let color of colorPalette"
                          type="button"
                          class="color-swatch"
                          [style.backgroundColor]="color"
                          [class.selected]="editForm.properties.textColor === color"
                          (click)="selectColor(color)"
                          [title]="color">
                  </button>
                </div>
              </div>
            </div>

            <!-- Italic -->
            <button type="button"
                    class="toolbar-toggle"
                    [class.active]="editForm.properties.italic"
                    (click)="editForm.properties.italic = !editForm.properties.italic"
                    [title]="t('tooltips.italic')">
              <em>I</em>
            </button>

            <!-- Underline -->
            <button type="button"
                    class="toolbar-toggle"
                    [class.active]="editForm.properties.underline"
                    (click)="editForm.properties.underline = !editForm.properties.underline"
                    [title]="t('tooltips.underline')">
              <u>U</u>
            </button>
          </div>

          <div class="form-group">
            <label for="angle">{{ t('fields.angle') }}:</label>
            <input id="angle" type="number" [(ngModel)]="editForm.properties.angle" min="0" max="360" class="form-input">
          </div>
        </div>

        <!-- Attachments List Properties -->
        <div *ngIf="editingElement.type === 'file-list'">
          <div class="form-group">
            <label for="attachmentsFontSize">{{ t('fields.fontSize') }}:</label>
            <input id="attachmentsFontSize" type="number" [(ngModel)]="editForm.properties.fontSize"
                   min="6" max="18" class="form-input">
          </div>

          <div class="form-group">
            <label for="attachmentsFontFamily">{{ t('fields.fontFamily') }}:</label>
            <select id="attachmentsFontFamily" [(ngModel)]="editForm.properties.fontFamily" class="form-input">
              <option value="Arial">{{ t('fonts.arial') }}</option>
              <option value="Times New Roman">{{ t('fonts.timesNewRoman') }}</option>
              <option value="Helvetica">{{ t('fonts.helvetica') }}</option>
              <option value="Courier">{{ t('fonts.courier') }}</option>
            </select>
          </div>
        </div>

        <!-- Signature Properties -->
        <div *ngIf="editingElement.type === 'signature'">
          <div class="form-group">
            <label for="sigBackgroundColor">{{ t('fields.backgroundColor') }}:</label>
            <input id="sigBackgroundColor" type="color" [(ngModel)]="editForm.properties.backgroundColor" class="form-input">
          </div>
          <div class="form-group">
            <label for="sigBorderColor">{{ t('fields.borderColor') }}:</label>
            <input id="sigBorderColor" type="color" [(ngModel)]="editForm.properties.borderColor" class="form-input">
          </div>
          <div class="form-group">
            <label for="borderWidth">{{ t('fields.borderWidth') }}:</label>
            <input id="borderWidth" type="number" [(ngModel)]="editForm.properties.borderWidth" min="0" max="10" class="form-input">
          </div>
          <div class="form-group">
            <label>
              <input type="checkbox" [(ngModel)]="editForm.properties.required" class="form-checkbox">
              {{ t('fields.required') }}
            </label>
          </div>
        </div>

        <!-- Digital Signature Properties -->
        <div *ngIf="editingElement.type === 'digital-signature'">
          <div class="form-group">
            <label for="digSigBackgroundColor">{{ t('fields.backgroundColor') }}:</label>
            <input id="digSigBackgroundColor" type="color" [(ngModel)]="editForm.properties.backgroundColor" class="form-input">
          </div>
          <div class="form-group">
            <label for="digSigBorderColor">{{ t('fields.borderColor') }}:</label>
            <input id="digSigBorderColor" type="color" [(ngModel)]="editForm.properties.borderColor" class="form-input">
          </div>
          <div class="form-group">
            <label for="digSigBorderWidth">{{ t('fields.borderWidth') }}:</label>
            <input id="digSigBorderWidth" type="number" [(ngModel)]="editForm.properties.borderWidth" min="0" max="10" class="form-input">
          </div>
          <div class="form-group">
            <label for="signatureMethod">{{ t('fields.signatureMethod') }}:</label>
            <select id="signatureMethod" [(ngModel)]="editForm.properties.signatureMethod" class="form-input">
              <option value="PKI">{{ t('signatureMethods.pki') }}</option>
              <option value="Adobe">{{ t('signatureMethods.adobe') }}</option>
              <option value="DocuSign">{{ t('signatureMethods.docusign') }}</option>
            </select>
          </div>
          <div class="form-group">
            <label for="certificateInfo">{{ t('fields.certificateInfo') }}:</label>
            <input id="certificateInfo" type="text" [(ngModel)]="editForm.properties.certificateInfo" class="form-input" [placeholder]="t('placeholders.certificateDetails')">
          </div>
          <div class="form-group">
            <label>
              <input type="checkbox" [(ngModel)]="editForm.properties.timestampRequired" class="form-checkbox">
              {{ t('fields.timestampRequired') }}
            </label>
          </div>
          <div class="form-group">
            <label>
              <input type="checkbox" [(ngModel)]="editForm.properties.required" class="form-checkbox">
              {{ t('fields.required') }}
            </label>
          </div>
        </div>

        <!-- Biometric Signature Properties -->
        <div *ngIf="editingElement.type === 'biometric-signature'">
          <div class="form-group">
            <label for="bioSigBackgroundColor">{{ t('fields.backgroundColor') }}:</label>
            <input id="bioSigBackgroundColor" type="color" [(ngModel)]="editForm.properties.backgroundColor" class="form-input">
          </div>
          <div class="form-group">
            <label for="bioSigBorderColor">{{ t('fields.borderColor') }}:</label>
            <input id="bioSigBorderColor" type="color" [(ngModel)]="editForm.properties.borderColor" class="form-input">
          </div>
          <div class="form-group">
            <label for="bioSigBorderWidth">{{ t('fields.borderWidth') }}:</label>
            <input id="bioSigBorderWidth" type="number" [(ngModel)]="editForm.properties.borderWidth" min="0" max="10" class="form-input">
          </div>
          <div class="form-group">
            <label for="deviceInfo">{{ t('fields.deviceInfo') }}:</label>
            <input id="deviceInfo" type="text" [(ngModel)]="editForm.properties.deviceInfo" class="form-input" [placeholder]="t('placeholders.deviceInfo')">
          </div>
          <div class="form-group">
            <label>
              <input type="checkbox" [(ngModel)]="editForm.properties.pressureSensitive" class="form-checkbox">
              {{ t('fields.pressureSensitive') }}
            </label>
          </div>
          <div class="form-group">
            <label>
              <input type="checkbox" [(ngModel)]="editForm.properties.velocityTracking" class="form-checkbox">
              {{ t('fields.velocityTracking') }}
            </label>
          </div>
          <div class="form-group">
            <label>
              <input type="checkbox" [(ngModel)]="editForm.properties.required" class="form-checkbox">
              {{ t('fields.required') }}
            </label>
          </div>
        </div>

        <!-- Initials Properties -->
        <div *ngIf="editingElement.type === 'initials'">
          <div class="form-group">
            <label for="distanceFromRight">{{ t('fields.distanceFromRight') }}:</label>
            <input id="distanceFromRight" type="number" [(ngModel)]="editForm.distanceFromRight" min="0" class="form-input">
          </div>
          <div class="form-group">
            <label for="distanceFromBottom">{{ t('fields.distanceFromBottom') }}:</label>
            <input id="distanceFromBottom" type="number" [(ngModel)]="editForm.distanceFromBottom" min="0" class="form-input">
          </div>
        </div>
      </div>

      <!-- Error message display -->
      <div class="modal-error" *ngIf="editModalError">
        <span class="error-icon">⚠️</span>
        <span class="error-text">{{ editModalError }}</span>
      </div>

      <div class="modal-footer" *ngIf="editingElement?.type === 'initials'">
        <button class="btn-secondary" (click)="closeEditModal()">{{ t('buttons.cancel') }}</button>
        <button class="btn-primary" (click)="saveElementProperties()">{{ t('buttons.save') }}</button>
        <button class="btn-primary" (click)="addInitialsToOtherPages()">{{ t('buttons.addToOtherPages') }}</button>
        <button class="btn-danger" (click)="deleteAllInitialsForSigner()">{{ t('buttons.deleteAll') }}</button>
      </div>
      <div class="modal-footer" *ngIf="editingElement?.type !== 'initials'">
        <button class="btn-secondary" (click)="closeEditModal()">{{ t('buttons.cancel') }}</button>
        <button class="btn-primary" (click)="saveElementProperties()">{{ t('buttons.save') }}</button>
      </div>
    </div>
  </div>
</div>
